import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FC } from 'react';

type PrescriptionsAccordionProps = {
  title: string;
  children: React.ReactNode;
};

const PrescriptionsAccordion: FC<PrescriptionsAccordionProps> = ({ title, children }) => {
  return (
    <Accordion
      sx={{
        boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.16)',
        backgroundColor: 'background.paper',
        borderRadius: 1,
        margin: (theme) => theme.spacing(0, 0, 3, 0),
        '&::before': { display: 'none' },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ fill: (theme) => theme.palette.common.black }} />}
        sx={{
          borderColor: 'divider',
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          padding: (theme) => theme.spacing(1.5, 3),
        }}
      >
        <Typography variant='h2'>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          padding: (theme) => theme.spacing(0, 3, 3, 3),
          margin: 0,
          backgroundColor: 'background.paper',
          borderBottomLeftRadius: 4,
          borderBottomRightRadius: 4,
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default PrescriptionsAccordion;
